<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add"
      >新增</a-button
    >
    <a-modal v-model="visible" centered title="添加模板" @ok="handleOk">
      <p>标题</p>
      <a-select
        v-model="form.templateNo"
        placeholder="请选择"
        style="width: 100%"
      >
        <a-select-option
          v-for="(item, index) in selectData"
          :key="index"
          :value="item.templateNo"
        >
          {{ item.templateTitle }}
        </a-select-option>
      </a-select>
      <p>模板ID</p>
      <a-input v-model="form.templateId"></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑模板" @ok="handleOktwo">
      <p>标题</p>
      <a-select
        v-model="forms.templateNo"
        placeholder="请选择"
        style="width: 100%"
      >
        <a-select-option
          v-for="(item, index) in selectData"
          :key="index"
          :value="item.templateNo"
        >
          {{ item.templateTitle }}
        </a-select-option>
      </a-select>
      <p>模板ID</p>
      <a-input v-model="forms.templateId"></a-input>
      <p>模板内容</p>
      <a-input v-model="forms.templateContent"></a-input>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="record => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  tmplMainList,
  tmplList,
  tmplAdd,
  tmplEdit,
  tmplDel
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "ID",
    dataIndex: "objId",
    align: "center",
    scopedSlots: { customRender: "objId" }
  },
  {
    title: "商家编号",
    dataIndex: "merchantsNo",
    align: "center",
    scopedSlots: { customRender: "merchantsNo" }
  },
  {
    title: "标题",
    dataIndex: "templateTitle",
    align: "center",
    scopedSlots: { customRender: "templateTitle" }
  },
  {
    title: "模板ID",
    dataIndex: "templateId",
    align: "center",
    scopedSlots: { customRender: "templateId" }
  },
  {
    title: "模板内容",
    dataIndex: "templateContent",
    align: "center",
    scopedSlots: { customRender: "templateContent" }
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      img: "",
      visible: false,
      visibletwo: false,
      limit: 10,
      page: 1,
      form: {
        templateNo: "",
        templateId: "",
        merchantsNo: ""
      },
      forms: {
        id: "",
        templateNo: "",
        templateId: "",
        templateContent: ""
      },
      mainTmpl: [
        {
          id: 1,
          title: "砍价进度通知"
        },
        {
          id: 2,
          title: "拼团结果通知"
        },
        {
          id: 3,
          title: "会员充值成功通知"
        },
        {
          id: 4,
          title: "活动预约通知"
        },
        {
          id: 5,
          title: "现金立减券即将过期提醒"
        },
        {
          id: 6,
          title: "秒杀活动开始提醒"
        },
        {
          id: 7,
          title: "游戏币变动通知"
        }
      ],
      selectData: []
    };
  },
  mounted() {
    this.getMainList();
    this.getData();
  },
  props: ["formInline"],
  methods: {
    getMainList() {
      tmplMainList({ page: 1, limit: 10 }).then(res => {
        this.selectData = res.data;
      });
    },
    getData() {
      this.data = [];
      tmplList({
        page: 1,
        limit: 10,
        merchantsNo: this.formInline.merchantsId
      }).then(res => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      tmplList({
        limit: 10,
        page: this.pagination.current,
        merchantsNo: this.formInline.merchantsId
      }).then(res => {
        this.data = res.data;
        this.loading = false;
      });
    },
    edit(row) {
      this.visibletwo = true;
      this.forms.id = row.objId;
      this.forms.templateNo = row.templateNo;
      this.forms.templateId = row.templateId;
      this.forms.templateContent = row.templateContent;
    },
    // 查询
    query() {
      this.loading = true;
      tmplList({
        limit: 10,
        page: 1,
        merchantsNo: this.formInline.merchantsId
      }).then(res => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      tmplDel(row.objId).then(res => {
        this.loading = false;
        this.getData();
        message.success(res.info);
      });
    },
    add() {
      this.visible = true;
      this.form = {};
      this.form.merchantsNo = this.formInline.merchantsId;
    },
    handleOk() {
      if (!this.form.templateNo) {
        message.warning("标题不能为空");
        return;
      }
      if (!this.form.templateId) {
        message.warning("模板ID不能为空");
        return;
      }
      this.visible = false;
      tmplAdd(this.form).then(res => {
        message.success(res.info);
        this.getData();
        this.form = {};
      });
    },
    handleOktwo() {
      if (!this.forms.templateNo) {
        message.warning("标题不能为空");
        return;
      }
      if (!this.forms.templateId) {
        message.warning("模板ID不能为空");
        return;
      }
      if (!this.forms.templateContent) {
        message.warning("模板内容不能为空");
        return;
      }
      console.log("---this.forms--->", this.form);
      this.visibletwo = false;
      tmplEdit(this.forms).then(res => {
        message.success(res.info);
        this.getData();
      });
    }
  }
};
</script>
<style scoped>
img {
  width: 110px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/right/merchants/tmplContent.vue